// The state a service shows on its canvas node.
import type { HttpServiceModelBase, NodeBadge, Service } from "@/types";

// The kinds that hold validators: the HTTP family (HttpServiceModelBase.validatorPipeline).
const HTTP_TYPES = ["http", "httpPaging", "webhook"];

export function nodeBadges(service: Service): NodeBadge[] {
  const badges: NodeBadge[] = [];

  if (service.isComponent) badges.push({ icon: "bi bi-puzzle", text: "Component" });

  const validatorCount = authoredValidatorCount(service);
  if (validatorCount > 0) badges.push({ icon: "bi bi-shield-check", text: validatorText(validatorCount) });

  return badges;
}

// Every authored validator counts, whatever its action.
function authoredValidatorCount(service: Service): number {
  const holdsValidators = HTTP_TYPES.includes(service.serviceModelType.$type ?? "");
  if (!holdsValidators) return 0;
  const http = service.serviceModelType as HttpServiceModelBase;
  // A stored service can lack the list, which the HTTP editor also allows for (ServiceModelHttp.vue:205).
  return (http.validatorPipeline ?? []).length;
}

function validatorText(count: number): string {
  return count === 1 ? "1 validator" : `${count} validators`;
}
